import React, {Component} from 'react';
import _ from 'lodash';

class PlaceDirectoryForm extends Component {
	render() {
		return <div className="directory-form">
			<form id="placeForm">
				<div className="field is-grouped">
					<div className="control is-expanded">
						<label htmlFor="name" className="label">Nombre / Razón social</label>
						<input type="text" id="name" ref="name" className="input" placeholder="Nombre de la institución" />
					</div>

					<div className="control is-expanded">
						<label htmlFor="owner" className="label">Titular</label>
						<input type="text" id="owner" ref="owner" className="input" placeholder="Nombre del titular" />
					</div>
					
					<div className="control">
						<label htmlFor="area" className="label">Área de incidencia</label>
						<div className="select">
							<select ref="area" id="area">
								<option selected disabled>--- Area ---</option>
								<option value="Alimentación">Alimentación</option>
								<option value="Educación">Educación</option>
								<option value="Participación política">Participación política</option>
								<option value="Seguridad">Seguridad</option>
								<option value="Cohesión social">Cohesión social</option>
								<option value="Empoderamiento económico">Empoderamiento económico</option>
								<option value="Salud">Salud</option>
								<option value="Vivienda">Vivienda</option>
							</select>
						</div>
					</div>
				</div>

				<div className="field is-grouped">
					<div className="control is-expanded">
						<label htmlFor="address" className="label">Calle</label>
						<input type="text" id="address" ref="address" className="input" placeholder="Calle y número" />
					</div>
					<div className="control is-expanded">
						<label htmlFor="address2" className="label">Colonia</label>
						<input type="text" id="address2" ref="address2" className="input" placeholder="Colonia" />
					</div>
				</div>

				<div className="field is-grouped">
					<div className="control">
						<label htmlFor="zipcode" className="label">Código postal</label>
						<input type="number" id="zipcode" ref="zipcode" className="input" placeholder="00000" />
					</div>

					<div className="control is-expanded">
						<label htmlFor="state" className="label">Estado</label>
						<input type="text" id="state" ref="state" className="input" placeholder="Estado" />
					</div>

					<div className="control is-expanded">
						<label htmlFor="city" className="label">Municipio</label>
						<input type="text" id="city" ref="city" className="input" placeholder="Municipio" />
					</div>
				</div>

				<div className="field is-grouped">
					<div className="control is-expanded">
						<label htmlFor="url" className="label">Página web</label>
						<input type="url" ref="url" id="url" className="input" placeholder="http://" />
					</div>
					
					<div className="control is-expanded">
						<label htmlFor="phone" className="label">Teléfono</label>
						<input type="tel" ref="phone" id="phone" className="input" placeholder="5555555555" />
					</div>

					<div className="control is-expanded">
						<label htmlFor="email" className="label">E-mail</label>
						<input type="email" id="email" ref="email" className="input" placeholder="ejemplo@dominio.com" />
					</div>
				</div>

				<div className="field is-grouped is-grouped-right">
					<div className="control">
						<button onClick={(e) => this.saveEntry(e)} className="button is-cdm-blue" type="button">Guardar</button>
					</div>
				</div>
			</form>
		</div>
	}

	saveEntry(e) {
		e.preventDefault();
		this.props.addEntry({
			id: this.props.nextId,
			area: this.refs.area.value,
			name: this.refs.name.value,
			owner: this.refs.owner.value,
			address: this.refs.address.value,
			address2: this.refs.address2.value,
			zipcode: _.toInteger(this.refs.zipcode.value),
			state: this.refs.state.value,
			city: this.refs.city.value,
			url: this.refs.url.value,
			phone: this.refs.phone.value,
			email: this.refs.email.value
		});
		this.refs.area.value = '';
		this.refs.name.value = '';
		this.refs.owner.value = '';
		this.refs.address.value = '';
		this.refs.address2.value = '';
		this.refs.zipcode.value = '';
		this.refs.state.value = '';
		this.refs.city.value = '';
		this.refs.url.value = '';
		this.refs.phone.value = '';
		this.refs.email.value = '';
	}
}

export default PlaceDirectoryForm;


// WEBPACK FOOTER //
// ./src/cdm-frontend/elements/directory/place-form.jsx